import { useEffect, useState, useRef } from 'react';
import { throttle } from 'lodash';

export const useWindowScrollY = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFixed, setIsFixed] = useState(true);
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    containerRef.current = document.getElementById('scrollable-container');

    const handleScroll = throttle(() => {
      const container = containerRef.current;

      if (!container) {
        setIsVisible(window.scrollY > 200);
        setIsFixed(true);
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const bottomRightMargin = 100;
      const isContainerInBottomRight = containerRect.bottom > viewportHeight - bottomRightMargin;

      setIsVisible(window.scrollY > 200);
      setIsFixed(isContainerInBottomRight);
    }, 100);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return { isVisible, isFixed };
};
